import React from 'react';

import { CurrencyFlag } from '@column/ui';

export const CurrencyIcon = ({ currencyCode }: { currencyCode?: string }) => <CurrencyFlag currency={currencyCode} />;
